import { useEffect, useState } from 'react'
import { svgAspectRatio } from '@/utils/mediaGallery'

/** Aspect ratio of the SVG at a (blob) URL, or null while loading or when it cannot be determined. */
export function useSvgAspectRatio(url: string | null): number | null {
  const [result, setResult] = useState<{ url: string; ratio: number | null } | null>(null)

  useEffect(() => {
    if (!url) return
    let cancelled = false
    fetch(url)
      .then((r) => r.text())
      .then((text) => {
        if (!cancelled) setResult({ url, ratio: svgAspectRatio(text) })
      })
      .catch(() => {
        if (!cancelled) setResult({ url, ratio: null })
      })
    return () => {
      cancelled = true
    }
  }, [url])

  return url && result?.url === url ? result.ratio : null
}
